"use client"

import { Check, Copy } from "lucide-react"
import { useState } from "react"

export function CopyButton({
  value,
  label,
  compact = false,
}: {
  value: string
  label: string
  compact?: boolean
}) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    window.setTimeout(() => setCopied(false), 1_800)
  }

  return (
    <button
      type="button"
      className={compact ? "hash-button" : "icon-button small-icon-button"}
      onClick={() => void copy()}
      title={copied ? "Copied" : label}
      aria-label={copied ? "Copied" : label}
    >
      {compact ? <code>{value.slice(0, 10)}…</code> : null}
      {copied ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />}
    </button>
  )
}
